export const optionalTour = {
  optionalTourCategory: "Categories",
  category: "Categories",
  query: "Keyword",
  region: "Destination",
};
